export default __webpack_public_path__ + "static/media/background_start.c59dfb9c.jpg";